import * as React from "react";
import { ReactElement } from 'react';


interface Props {
	style?: React.CSSProperties;
}

export const SvgComponentOrcidLink = (props: Props): ReactElement => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		xmlSpace="preserve"
		id="Ebene_1"
		x={0}
		y={0}
		viewBox="0 0 464.1 317"
		{...props}
	>
		<style>{".st2{fill:#fff}"}</style>
		<g id="Gruppe_62" transform="translate(-317 -2086)">
			<path
				id="add-to-list"
				d="M774.4 2253.8h-38.3v-38.3c0-6.8-4.5-6.8-11.3-6.8s-11.3 0-11.3 6.8v38.3h-38.3c-6.8 0-6.8 4.5-6.8 11.3s0 11.3 6.8 11.3h38.3v38.3c0 6.8 4.5 6.8 11.3 6.8s11.3 0 11.3-6.8v-38.3h38.3c6.8 0 6.8-4.5 6.8-11.3s-.1-11.3-6.8-11.3z"
				className="st0 text-primary"
				style={props.style}
			/>
			<g id="Gruppe_4" transform="translate(317 2086)">
				<g id="Gruppe_3">
					<path
						id="Pfad_1"
						d="M317 158.5C317 246 246 317 158.5 317S0 246 0 158.5 71 0 158.5 0 317 71 317 158.5"
						style={{
							fill: "#a6ce39",
						}}
					/>
					<path
						id="Pfad_2"
						d="M139.2 100.6c24.1 1.2 48.1-.1 71.1 4.2 30.5 5.7 48.9 34.4 46.4 65.6-2.3 30.3-25.6 55.6-56.3 58.3-20 1.8-40.3.3-61.2.3V100.6zm18.9 111.2c13.6 0 26.7 1.3 39.5-.3 23-2.9 37.7-19.9 39.9-43.6 1.8-19.2-9.5-40-28.1-44.9-16.4-4.3-33.9-1.9-51.2-3.9l-.1 92.7z"
						className="st2"
					/>
					<path
						id="Rechteck_17"
						d="M93.8 101.5h17.3v127.4H93.8z"
						className="st2"
					/>
					<path
						id="Pfad_3"
						d="M89.7 74.3c0-7.1 5.7-12.8 12.8-12.8 7.1 0 12.8 5.7 12.8 12.8 0 7.1-5.7 12.8-12.8 12.8-7.1 0-12.8-5.7-12.8-12.8"
						className="st2"
					/>
				</g>
			</g>
		</g>
	</svg>
);

export default SvgComponentOrcidLink;
